<template>
    <div v-if="links" class="topbar-menu navbar-start">
        <div class="container">
            <div class="navbar-list">
                <router-link
                    v-for="link in links"
                    :key="link.name"
                    class="navbar-item"
                    :to="link.route"
                >
                    <div class="navbar-image"
                        :style="`background-image: url('/static/topbar/menu/${theme}/${link.name}.${extension}');`"
                    >
                    </div>
                    <div class="navbar-text">{{link.text | translate}}</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import menuHelper from '../../../helpers/menu.helper';
import priorityNav from 'priority-nav';
import isMobile from 'ismobilejs';

export default {
    name: 'topbar-menu',
    data() {
        return {
            links: null,
            isMobile: isMobile.phone
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        theme() {
            return (this.client && this.client.view && this.client.view.style.theme) || 'dark';
        },
        extension() {
            return this.theme === 'cashcasino' ? 'png' : 'svg';
        }
    },
    async mounted() {
        this.links = await menuHelper.getMenuLinks();
        if (this.theme != 'cashcasino'){
            this.init();
        }
    },
    methods: {
        async init() {
            if(!this.isMobile){
                await this.$nextTick();
                this.initResponseMenu();
            }
        },
        initResponseMenu() {
            const nav = priorityNav.init({
                mainNavWrapper: '.container',
                mainNav: '.navbar-list',
                navDropdownLabel: '<svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M0 0h6v6H0zM8 0h6v6H8zM8 8h6v6H8zM0 8h6v6H0z"/></svg> ' + Vue.i18n.translate("components.common.topbar.more"),
                navDropdownClassName: "navbar-dropdown",
                navDropdownToggleClassName: "navbar-dropdown-toggle",
                breakPoint: 0,
            });
        }
    }
};
</script>
<style>
.topbar-menu .container{
    display: flex;
}
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/topbar/topbar-menu.vue